import { conteoPorClave } from '../../lib/sesion';
import { Barras } from './Barras';
import type { PropsProyeccion } from './registro';

/**
 * Proyecciones específicas por primitiva (superficie Pantalla). Tally por
 * opción/valor SIN autores (C7): agregado legítimo de sala. La primitiva
 * `texto` no tiene proyección propia todavía: la galería y la nube de
 * palabras llegan con D5c (fidelidad de `proyeccion.vista`).
 */

/** Proyección de la primitiva `voto`: barras por opción elegida. */
export function ProyeccionVoto({ aportes, total }: PropsProyeccion) {
  const porOpcion = conteoPorClave(aportes, 'opcion');
  if (porOpcion.size === 0) return null;
  return (
    <Barras
      titulo="Cómo votó la sala"
      filas={[...porOpcion.entries()].map(([k, n]) => ({ etiqueta: k, n }))}
      total={total}
    />
  );
}

/** Proyección de la primitiva `posicion`: barras por valor de la escala. */
export function ProyeccionPosicion({ aportes, total }: PropsProyeccion) {
  const porValor = conteoPorClave(aportes, 'valor');
  if (porValor.size === 0) return null;
  return (
    <Barras
      titulo="Posición de la sala"
      filas={[...porValor.entries()].map(([k, n]) => ({ etiqueta: k, n }))}
      total={total}
    />
  );
}
